<template>
  <div data-test="review">
    <p class="mb-2 text-xs font-bold uppercase tracking-wider text-gray-500">{{ t("title") }}</p>

    <div class="flex flex-col gap-2 rounded-xl bg-gray-50 px-4 py-3 text-sm">
      <ul class="flex flex-col gap-1.5">
        <li v-for="request in requests" :key="request.field" :data-test="`review-${request.field}`">
          <span class="font-semibold">{{ t(`claim.declaration_field.${request.field}`) }}</span>
          <span v-if="request.message" class="ml-1 text-gray-600">— {{ request.message }}</span>
        </li>
      </ul>
    </div>
    <p class="mt-2 text-xs text-gray-500">{{ t("hint") }}</p>

    <div class="mt-4 flex justify-end gap-2">
      <SecondaryButton :disabled="submitting" data-test="edit" @click="$emit('edit')">{{ t("edit") }}</SecondaryButton>
      <GenericButton
        default-style="bg-yellow-400 hover:bg-yellow-500 border-transparent text-yellow-900"
        :disabled="submitting"
        data-test="confirm-send"
        @click="$emit('confirm')"
      >
        {{ t("confirm", requests.length) }}
      </GenericButton>
    </div>
  </div>
</template>

<script>
import { useI18n } from "vue-i18n";
import { GenericButton, SecondaryButton } from "@estaly/ui";

export default {
  name: "ClaimComplementRequestReview",

  components: { GenericButton, SecondaryButton },

  setup() {
    const { t } = useI18n();
    return { t };
  },

  props: {
    // Demandes telles qu'envoyées au client : { field, message }.
    requests: {
      type: Array,
      required: true,
    },
    submitting: {
      type: Boolean,
      default: false,
    },
  },

  emits: ["edit", "confirm"],
};
</script>

<i18n src="./ClaimComplementRequestReview.i18n.json"></i18n>
